import React, { useState } from 'react';
import { useUserCoupons } from '../hooks/useUserCoupons';
import '../styles/modal.scss';

export const AddUserCouponModal = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({
    couponCode: '',
    discountValue: '',
    expireType: 'usage',
    allowedUsageTimes: '',
    expireDate: ''
  });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const { createCoupon } = useUserCoupons();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.couponCode || formData.couponCode.trim().length < 2) {
      setError('كود الكوبون يجب أن يكون حرفين على الأقل');
      return;
    }

    if (!formData.discountValue || formData.discountValue <= 0) {
      setError('قيمة الخصم يجب أن تكون أكبر من 0');
      return;
    }

    if (formData.expireType === 'usage' && (!formData.allowedUsageTimes || formData.allowedUsageTimes <= 0)) {
      setError('عدد مرات الاستخدام المسموحة مطلوب');
      return;
    }

    if (formData.expireType === 'date' && !formData.expireDate) {
      setError('تاريخ انتهاء الصلاحية مطلوب');
      return;
    }

    setIsLoading(true);
    setError('');

    try {
      const couponData = {
        couponCode: formData.couponCode.trim(),
        discountValue: Number(formData.discountValue),
        expireType: formData.expireType
      };

      if (formData.expireType === 'usage') {
        couponData.allowedUsageTimes = Number(formData.allowedUsageTimes);
      } else {
        couponData.expireDate = formData.expireDate;
      }

      const result = await createCoupon(couponData);
      if (result) {
        handleClose();
      }
    } catch (error) {
      console.error('Error creating user coupon:', error);
      setError(error.message || 'حدث خطأ أثناء إنشاء كوبون المستخدم');
    } finally {
      setIsLoading(false);
    }
  };

  const handleClose = () => {
    setFormData({
      couponCode: '',
      discountValue: '',
      expireType: 'usage',
      allowedUsageTimes: '',
      expireDate: ''
    });
    setError('');
    onClose();
  };

  const handleChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
    setError('');
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={handleClose}>
      <div className="modal-content coupon-modal" onClick={e => e.stopPropagation()}>
        <h2 className="TXT-heading2 color-normal">إنشاء كوبون مستخدم جديد</h2>

        <form onSubmit={handleSubmit}>
          <div className="input-group">
            <label>كود الكوبون</label>
            <input
              type="text"
              value={formData.couponCode}
              onChange={(e) => handleChange('couponCode', e.target.value)}
              placeholder="أدخل كود الكوبون"
              minLength="2"
              required
            />
          </div>

          <div className="input-group">
            <label>قيمة الخصم (دينار)</label>
            <input
              type="number"
              value={formData.discountValue}
              onChange={(e) => handleChange('discountValue', e.target.value)}
              placeholder="أدخل المبلغ"
              min="1"
              required
            />
          </div>

          <div className="input-group">
            <label>نوع انتهاء الصلاحية</label>
            <select
              value={formData.expireType}
              onChange={(e) => handleChange('expireType', e.target.value)}
            >
              <option value="usage">عدد مرات الاستخدام</option>
              <option value="date">تاريخ محدد</option>
            </select>
          </div>

          {formData.expireType === 'usage' ? (
            <div className="input-group">
              <label>عدد مرات الاستخدام المسموحة</label>
              <input
                type="number"
                value={formData.allowedUsageTimes}
                onChange={(e) => handleChange('allowedUsageTimes', e.target.value)}
                placeholder="أدخل عدد المرات"
                min="1"
                required
              />
            </div>
          ) : (
            <div className="input-group">
              <label>تاريخ انتهاء الصلاحية</label>
              <input
                type="date"
                value={formData.expireDate}
                onChange={(e) => handleChange('expireDate', e.target.value)}
                min={new Date().toISOString().split('T')[0]}
                required
              />
            </div>
          )}

          {error && <div className="error-message">{error}</div>}

          <div className="modal-actions">
            <button
              type="button"
              className="cancel-btn"
              onClick={handleClose}
              disabled={isLoading}
            >
              إلغاء
            </button>
            <button
              type="submit"
              className="submit-btn"
              disabled={isLoading}
            >
              {isLoading ? (
                <>
                  <span className="loading-spinner"></span>
                  جاري الإنشاء...
                </>
              ) : 'إنشاء'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddUserCouponModal;
